import Steps from './components/Steps';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'steps',
  pluginComponent: Steps,
});
